// Deprecated

'use strict';

module.exports = function (obj) { return typeof obj === 'function'; };



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/es5-ext/object/is-callable.js
 ** module id = 71
 ** module chunks = 2
 **/